module.exports = __webpack_public_path__ + "d6c3947430e9d7eea980c9a8d744dded.pdf";